// extracted by mini-css-extract-plugin
module.exports = {"button":"AppNewsActions_button__3lUyj","menuIcon":"AppNewsActions_menuIcon__KkP5w","openButton":"AppNewsActions_openButton__3u3Y1"};